import React from 'react';
import { useParams } from 'react-router-dom';
import { WidthProvider, Responsive } from 'react-grid-layout';
import { Box } from '@mui/material';
import PowerGraphHandler from '../fpm/handlers/PowerGraphHandler';
import { PowerCard } from '../fpm/cards/PowerCard';

const ResponsiveGridLayout = WidthProvider(Responsive);

/**
 * GolfTrack Power dashboard. Pulls all data from the FPM backend (see
 * fpmEndpointLink / fpmWebsocketLink in src/index.tsx) so there's a single
 * source of truth shared with the FPM app. BuildingID comes from the URL
 * (/power/:BuildingID) because GolfTrack views are scoped to one club.
 */
const BuildingGrid: React.FC = () => {
  const { BuildingID } = useParams();

  const layouts = {
    lg: [
      { i: 'graph', x: 0, y: 3, w: 9, h: 9, minW: 6, minH: 8 },
      { i: 'power-card', x: 0, y: 0, w: 9, h: 3, minW: 2, minH: 3 },
    ],
    md: [
      { i: 'graph', x: 0, y: 3, w: 6, h: 9, minW: 4, minH: 8 },
      { i: 'power-card', x: 0, y: 0, w: 6, h: 3, minW: 2, minH: 3 },
    ],
    sm: [
      { i: 'graph', x: 0, y: 4, w: 3, h: 8, minW: 2, minH: 7 },
      { i: 'power-card', x: 0, y: 0, w: 3, h: 4, minW: 2, minH: 4 },
    ],
    xs: [
      { i: 'graph', x: 0, y: 5, w: 1, h: 8, minW: 1, minH: 7 },
      { i: 'power-card', x: 0, y: 0, w: 1, h: 5, minW: 1, minH: 5 },
    ],
  };

  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      <Box sx={{ minHeight: '100%', width: '100%' }}>
        <ResponsiveGridLayout
          className="layout"
          layouts={layouts}
          breakpoints={{ lg: 1200, md: 996, sm: 768, xs: 480 }}
          cols={{ lg: 9, md: 6, sm: 3, xs: 1 }}
          rowHeight={100}
          margin={[10, 10]}
          compactType={null}
          draggableCancel=".cancelSelectorName"
          isDraggable={false}
          isResizable={false}
        >
          <div key="power-card" className="card-gauge">
            <PowerCard BuildingID={BuildingID} />
          </div>
          <div key="graph" className="card-gauge">
            <PowerGraphHandler BuildingID={BuildingID} />
          </div>
        </ResponsiveGridLayout>
      </Box>
    </Box>
  );
};

export default BuildingGrid;
